import { render, staticRenderFns } from "./MapPoint.vue?vue&type=template&id=39bb3ccb&scoped=true&"
import script from "./MapPoint.vue?vue&type=script&lang=js&"
export * from "./MapPoint.vue?vue&type=script&lang=js&"
import style0 from "./MapPoint.vue?vue&type=style&index=0&id=39bb3ccb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb3ccb",
  null
  
)

export default component.exports